import { INACTIVE, TERMINATED } from "../dashboard/clients/enums/clientStatusTypes";

export const isAssociatedClientUserReadOnly = (client) => {
    const clientStatus = [TERMINATED.value, INACTIVE.value];
    return client && clientStatus.includes(client.clientStatusType);
};

export const getClientIDFromURL = () => {
    const match = window.location.pathname.match(/clients\/(\d+)/);
    return match ? match[1] : null;
};

export const fixClientURL = (correctClientId) => {
    const newUrl = window.location.pathname.replace(/clients\/\d+/, `clients/${correctClientId}`);
    window.location.replace(newUrl);
};

export const didUserHaveAssociatedClientError = () => {
  if (sessionStorage.getItem("hasAssociatedClientError") === "true") {
    sessionStorage.removeItem("hasAssociatedClientError");
    return true;
  }
  return false;
}


// WEBPACK FOOTER //
// ./src/components/common/clientHelper.js